<template>
  <a-modal
          title="请输入监测区域"
          okText="确认"
          cancelText="取消"
          width="500px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @ok="handleOk"
          @cancel="handleCancel"
  >
    <a-form-model layout="horizontal" ref="ruleForm" :model="form" :rules="rules" :label-col="{span:0}"
                  :wrapper-col="{span:24}">
      <a-form-model-item prop="regionCode">
        <a-row>
          <a-col span="8" style="text-align: right;padding-right: 40px">选择区县</a-col>
          <a-col span="16">
            <a-ext-qu-xian-select :cityCode="param.regionCode" v-model="form.region"></a-ext-qu-xian-select>
          </a-col>
        </a-row>

      </a-form-model-item>
      <a-form-model-item prop="pickCount">
        <a-row>
          <a-col span="8" style="text-align: right;padding-right: 40px">数量</a-col>
          <a-col span="16">
            <a-input-number style="width: 100%" id="inputNumber" v-model="form.pickCount" :min="0" :max="10000"/>
          </a-col>
        </a-row>


      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import AExtQuXianSelect from '../../../components/AntDesignExt/All/AExtQuXianSelect'

export default {
    name: "FormModel",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        param: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    components: {AExtQuXianSelect},
    data() {
        return {
            confirmLoading: false,
            form: {
                region: undefined,
                pickCount: 0
            },
            rules: {
                pickCount: [{required: true, message: '请输入文本框内容', trigger: 'blur'},],
            },
        };
    },
    created() {
        this.initForm();
    },
    methods: {
        initForm() {

        },
        handleOk(e) {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.$emit("update:visible", false)
                    this.$emit("dialogBack", {
                        regionName: this.form.region.name,
                        regionCode: this.form.region.code,
                        pickCount: this.form.pickCount
                    });
                } else {
                    return false;
                }
            });
        },
        handleCancel(e) {
            this.$emit("update:visible", false)
        },
    },
}
</script>

<style scoped lang="scss">

  /*/deep/ .ant-modal-body{*/
  /*height: 70vh;*/
  /*overflow-y: scroll;*/
  /*}*/

</style>